import { render } from "./UserOrganizationTab.vue?vue&type=template&id=0dc5f762"
import script from "./UserOrganizationTab.vue?vue&type=script&lang=js"
export * from "./UserOrganizationTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__